<div class="gp-lane">
    <!-- Lane header -->
    <div
        class="gp-lane-header {{ lane.action?.headerClassList }}"
        [cmpsTooltipTrigger]="lane.action?.tooltip | translate"
        [openDelay]="300"
    >
        <cmps-icon
            class="gp-lane-header__icon"
            [svgIcon]="lane.action?.icon"
        ></cmps-icon>
        <h2 class="gp-lane-header__label">
            {{ lane.action?.label | translate }}
        </h2>
        <cmps-badge
            [cmpsBadge]="'' + lane.rows.length"
            cmpsBadgeBgColor="rgba(255,255,255,0.6)"
            cmpsBadgeTextColor="rgba(0,0,0,0.7)"
        ></cmps-badge>
    </div>

    <!-- Cards -->
    <div class="gp-lane-cards">
        <button
            type="button"
            class="gp-lane-card"
            *ngFor="let r of lane.rows; trackBy: _trackByRow"
            [attr.aria-label]="
                (lane.action?.label | translate) + ' — ' + r.name
            "
            (click)="_onCardClick(r)"
        >
            <cmps-icon
                svgIcon="account-circle"
                class="cmps-cdk-w-28px cmps-cdk-h-28px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit {{
                    r.persona?.iconFill
                }}"
            ></cmps-icon>
            <span class="gp-lane-card__name-group">
                <span class="gp-lane-card__name">{{ r.name }}</span>
                <cmps-badge
                    *ngIf="_actionCount(r) > 1"
                    [cmpsBadge]="'' + _actionCount(r)"
                    [cmpsBadgeClassName]="
                        'cmps-gp-bg-color-ukn-100 cmps-gp-color-ukn-106'
                    "
                ></cmps-badge>
            </span>
            <span
                class="gp-persona-pill {{
                    r.persona?.rowClassList
                }} gp-lane-card__pill gp-persona-pill--text"
            >
                {{ r.persona?.label | translate }}
            </span>
            <span
                class="gp-persona-pill {{
                    r.persona?.rowClassList
                }} gp-lane-card__pill gp-persona-pill--icon"
                [cmpsTooltipTrigger]="r.persona?.label | translate"
                [attr.aria-label]="r.persona?.label | translate"
            >
                <cmps-icon
                    class="cmps-cdk-w-24px cmps-cdk-h-24px cmps-cdk-nested:cmps-cdk-w-inherit cmps-cdk-nested:cmps-cdk-h-inherit"
                    [svgIcon]="r.persona?.icon"
                    aria-hidden="true"
                ></cmps-icon>
            </span>
            <span
                class="gp-lane-card__arrow"
                aria-hidden="true"
                >›</span
            >
        </button>
    </div>
</div>
